var exports = {
  "w": "x0a7806d5--d987c1--postfix",
};

module.exports = exports;
